import { render } from "./DMMessageButtons.vue?vue&type=template&id=ce77a7c8&scoped=true"
import script from "./DMMessageButtons.vue?vue&type=script&lang=js"
export * from "./DMMessageButtons.vue?vue&type=script&lang=js"

import "./DMMessageButtons.vue?vue&type=style&index=0&id=ce77a7c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce77a7c8"]])

export default __exports__